module.exports = __webpack_public_path__ + "static/img/icon h tpys.cbac3fa0.svg";